import { render, staticRenderFns } from "./venue-events.page.vue?vue&type=template&id=17ce8263&scoped=true&"
import script from "./venue-events.page.vue?vue&type=script&lang=js&"
export * from "./venue-events.page.vue?vue&type=script&lang=js&"
import style0 from "./venue-events.page.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./venue-events.page.vue?vue&type=style&index=1&id=17ce8263&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ce8263",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
